var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar-container"},[_c('div',{staticClass:"badge"},[_c('div',{staticClass:"has-s-heading-size level"},[_vm._v(_vm._s(_vm.level))])]),_c('div',{staticClass:"profile-image"},[_c('img',{attrs:{"src":_vm.imageUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }